(() => {
  // Dialog focus is retained for accessibility; pointer use should not inherit its keyboard ring.
  document.addEventListener('pointerdown', () => document.documentElement.classList.add('cart-pointer-input'), true);
  document.addEventListener('keydown', event => {
    if (!event.metaKey && !event.altKey && !event.ctrlKey) document.documentElement.classList.remove('cart-pointer-input');
  }, true);
  const closeIcon = '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>';
  let sequence = 0;
  function mount(root, { host = null, onClose = null } = {}) {
  if (!root) return;
  root.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
    const input = button.parentElement.querySelector('input');
    if (button.dataset.quantityStep === '1') input.stepUp(); else input.stepDown();
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }));
  const endpoint = root.dataset.personalizationEndpoint || '/apps/3d-personalization';
  const detailLoads = new Map();
  async function loadDetails(details) {
    if (destroyed || !details.open || !details.matches('details[data-server-details]') || detailLoads.get(details)?.controller) return;
    const article = details.closest('[data-cart-line-key]'), lineKey = article?.dataset.cartLineKey;
    if (!lineKey) return;
    let state = detailLoads.get(details);
    if (!state) {
      const status = document.createElement('p');
      status.setAttribute('role', 'status');
      details.append(status);
      state = { status, controller: null }; detailLoads.set(details, state);
    }
    const controller = new AbortController(); state.controller = controller;
    const current = () => !destroyed && !controller.signal.aborted && root.contains(article) && article.dataset.cartLineKey === lineKey;
    const list = details.querySelector('dl'); list.hidden = true;
    state.status.replaceChildren(); state.status.textContent = 'Loading personalization details…';
    details.setAttribute('aria-busy', 'true');
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const cartResponse = await fetch(`${globalThis.Shopify?.routes?.root || '/'}cart.js`, {
        credentials: 'same-origin', cache: 'no-store', signal: controller.signal, headers: { Accept: 'application/json' },
      });
      if (!cartResponse.ok) throw Error('Unavailable');
      const cart = await cartResponse.json();
      if (!current()) return;
      const line = cart.items?.find(item => item.key === lineKey), properties = line?.properties || {};
      const requestId = properties['_3D Heirloom Request'], revisionId = properties['_3D Heirloom Revision'];
      const variantId = String(line?.variant_id || '');
      if ((properties['_design_schema'] && properties['_design_schema'] !== '3dh-server-v1') || properties['_parent_design_id'] || properties['_linked_item_type']
        || requestId !== article.dataset.reviewRequestId || !/^3DH-[A-F0-9]{12}$/.test(requestId || '')
        || !/^3DHR-[A-F0-9]{20}$/.test(revisionId || '') || !/^[1-9]\d{0,24}$/.test(variantId)) throw Error('Unavailable');
      const assetToken = properties['_3D Heirloom Asset Refs'];
      const response = await fetch(`${endpoint}/v1/cart-details`, {
        method: 'POST', credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ requestId, revisionId, variantId, ...(assetToken ? { assetToken } : {}) }] }),
      });
      if (!response.ok) throw Error('Unavailable');
      const data = await response.json();
      if (!current()) return;
      const rows = Array.isArray(data.items) ? data.items.filter(row => row?.requestId === requestId && row.revisionId === revisionId && row.variantId === variantId) : [];
      const fields = rows.length === 1 ? rows[0].lineItemProperties : null;
      const names = ['Photo 1', 'Photo 2', 'Photo 3', 'Engraving', 'Font', 'Font size', 'Names', 'Base text'];
      const visible = names.filter(name => typeof fields?.[name] === 'string' && fields[name].trim() && fields[name].length <= 5000);
      if (!visible.length) throw Error('Unavailable');
      list.replaceChildren(...visible.map(name => {
        const row = document.createElement('div'), label = document.createElement('dt'), value = document.createElement('dd');
        label.textContent = name; value.textContent = fields[name];
        value.setAttribute('style', 'overflow-wrap:anywhere;min-width:0');
        row.append(label, value); return row;
      }));
      list.hidden = false; state.status.remove(); delete details.dataset.serverDetails; detailLoads.delete(details);
    } catch {
      if (destroyed || !root.contains(article) || article.dataset.cartLineKey !== lineKey) return;
      state.status.textContent = 'Personalization details are temporarily unavailable. ';
      const retry = document.createElement('button'); retry.type = 'button'; retry.textContent = 'Try again';
      retry.addEventListener('click', () => loadDetails(details)); state.status.append(retry);
    } finally {
      clearTimeout(timer); state.controller = null; details.removeAttribute('aria-busy');
    }
  }
  const detailsToggled = event => { if (event.target.matches?.('details[data-server-details]')) return loadDetails(event.target); };
  root.addEventListener('toggle', detailsToggled, true);
  const identity = root.dataset.customerEmail ? `?customer_email=${encodeURIComponent(root.dataset.customerEmail)}` : '';
  const items = [...root.querySelectorAll('[data-review-request-id],[data-review-design-id]')].map(article => ({
    article, requestId: article.dataset.reviewRequestId, designId: article.dataset.reviewDesignId,
    requestVersion: 0,
    title: article.querySelector('h2')?.textContent.trim() || 'Your personalized item',
    slot: article.querySelector('[data-preview-slot]'), selected: null, row: null, feedback: '',
  })).filter(item => item.slot && (item.requestId || item.designId));
  const cartItems = [...items];
  let paidSection = null, orderStatus = null;
  const emptyCart = root.dataset.cartCount === '0';
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
  const imagesFor = row => row?.designUrls?.length ? row.designUrls : row?.designUrl ? [row.designUrl] : [];
  const excluded = row => ['cancelled', 'refunded', 'payment-refunded'].includes(row?.productionStatus) || ['cancelled', 'refunded', 'payment-refunded', 'voided'].includes(row?.financialStatus);
  const readOnly = row => excluded(row) || ['in-production', 'qc', 'shipped', 'completed'].includes(row?.productionStatus);
  const matches = (item, row) => (item.requestId && item.requestId === row.requestId) || (item.designId && item.designId === row.designId);
  const titleId = `cart-design-title-${++sequence}`, feedbackId = `cart-design-feedback-${sequence}`;
  const drawer = document.createElement(host ? 'section' : 'dialog');
  drawer.className = 'cart-design-drawer' + (host ? ' cart-design-embedded' : '');
  if (host) drawer.hidden = true;
  drawer.setAttribute('aria-labelledby', titleId);
  const viewer = document.createElement('dialog');
  viewer.className = 'cart-design-viewer';
  viewer.setAttribute('aria-label', 'Design preview image');
  viewer.innerHTML = `<button type="button" data-viewer-close aria-label="Close enlarged image">${closeIcon}</button><img alt="">`;
  (host || root).append(drawer, viewer);
  let active = null;
  let scrollFrame = 0, scrollingStrip = null;
  function stopThumbnailScroll() {
    if (scrollFrame) cancelAnimationFrame(scrollFrame);
    scrollFrame = 0;
    scrollingStrip?.classList.remove('is-scrolling');
    scrollingStrip = null;
  }
  function scrollToThumbnail(card, animate) {
    stopThumbnailScroll();
    scrollFrame = requestAnimationFrame(() => {
      const strip = card.parentElement, max = Math.max(0, strip.scrollWidth - strip.clientWidth);
      const target = Math.max(0, Math.min(max, card.offsetLeft - (strip.clientWidth - card.offsetWidth) / 2));
      const start = strip.scrollLeft, distance = target - start;
      scrollFrame = 0;
      if (!animate || matchMedia('(prefers-reduced-motion: reduce)').matches || Math.abs(distance) < 1) {
        strip.scrollLeft = target;
        return;
      }
      let rebound = Math.sign(distance) * Math.min(4, Math.abs(distance) * .04);
      // At an edge, rebound inward so native scroll limits cannot swallow the motion.
      if (target + rebound < 0 || target + rebound > max) rebound = -rebound;
      scrollingStrip = strip;
      strip.classList.add('is-scrolling');
      let began;
      function step(now) {
        began ??= now;
        const progress = Math.min((now - began) / 440, 1);
        strip.scrollLeft = progress < .7
          ? start + distance * (1 - (1 - progress / .7) ** 3)
          : target + rebound * Math.sin(Math.PI * (progress - .7) / .3) ** 2;
        if (progress < 1) scrollFrame = requestAnimationFrame(step);
        else { strip.scrollLeft = target; stopThumbnailScroll(); }
      }
      scrollFrame = requestAnimationFrame(step);
    });
  }
  viewer.querySelector('button').addEventListener('click', () => viewer.close());
  viewer.addEventListener('click', event => { if (event.target === viewer) viewer.close(); });
  const cancel = event => {
    if (event.target !== (host || drawer)) return;
    if (active?.saving) { event.preventDefault(); return; }
    if (host && active) { event.preventDefault(); closePanel(); }
  };
  (host || drawer).addEventListener('cancel', cancel);
  drawer.addEventListener('click', event => { if (!host && event.target === drawer && !active?.saving) closePanel(); });
  function leave() {
    stopThumbnailScroll();
    if (active) {
      active.feedback = drawer.querySelector('textarea')?.value || '';
      active.slot.querySelector('[data-preview-open]')?.focus({ preventScroll: true });
    }
    document.documentElement.classList.remove('cart-design-open');
    active = null;
  }
  function closePanel() {
    if (active?.saving) return;
    if (!host) { drawer.close(); return; }
    drawer.hidden = true;
    host.classList.remove('is-reviewing');
    host.setAttribute('aria-labelledby', 'HeirloomCartTitle');
    leave();
    onClose?.();
  }
  const closed = () => { if (host) { drawer.hidden = true; host.classList.remove('is-reviewing'); host.setAttribute('aria-labelledby', 'HeirloomCartTitle'); } leave(); onClose?.(); };
  (host || drawer).addEventListener('close', closed);

  function state(item, message, retry = false) {
    item.slot.hidden = false;
    item.slot.innerHTML = `<div class="cart-design-summary-state"><span aria-hidden="true">◷</span><span role="status">${message}</span>${retry ? '<button type="button" data-preview-retry>Try again</button>' : ''}</div>`;
    item.slot.querySelector('[data-preview-retry]')?.addEventListener('click', refresh);
  }

  function hide(item) {
    item.slot.hidden = true;
    item.slot.innerHTML = '';
  }

  function orderNotice(message, retry = false, login = false) {
    orderStatus?.remove(); orderStatus = null;
    if (!message) return;
    orderStatus = document.createElement('p');
    orderStatus.dataset.orderDesignStatus = '';
    orderStatus.className = 'cart-order-design-status';
    orderStatus.setAttribute('role', 'status');
    orderStatus.textContent = message;
    if (login) {
      const link = document.createElement('a');
      link.href = '/customer_authentication/login?return_to=%2F%3Fopen_cart%3D1';
      link.textContent = 'Sign in to view your order designs.';
      orderStatus.append(' ', link);
    }
    if (retry) {
      const button = document.createElement('button'); button.type = 'button'; button.textContent = 'Try again';
      button.addEventListener('click', () => void refresh()); orderStatus.append(' ', button);
    }
    (root.querySelector('.simple-cart-items') || root.querySelector('.simple-cart-inner') || root).append(orderStatus);
  }

  function syncPaid(rows) {
    const paid = rows.filter(row => row.paid === true && row.previewRequested === true && !excluded(row) && row.requestId && !cartItems.some(item => matches(item, row)));
    const old = items.filter(item => item.orderDesign);
    for (const item of old) if (!paid.some(row => matches(item, row))) {
      if (active === item) { item.saving = false; closePanel(); }
      item.article.remove(); items.splice(items.indexOf(item), 1);
    }
    if (!paid.length) { paidSection?.remove(); paidSection = null; return; }
    if (!paidSection) {
      paidSection = document.createElement('section'); paidSection.dataset.paidDesigns = ''; paidSection.className = 'cart-order-designs';
      paidSection.innerHTML = '<h2>Recent order designs</h2>';
      (root.querySelector('.simple-cart-items') || root.querySelector('.simple-cart-inner') || root).append(paidSection);
    }
    for (const row of paid) {
      let item = items.find(item => item.orderDesign && matches(item, row));
      if (!item) {
        const article = document.createElement('article'); article.className = 'cart-order-design';
        article.innerHTML = '<h3></h3><p class="cart-order-design-order"></p><div class="simple-cart-preview-slot" data-preview-slot></div>';
        paidSection.append(article);
        item = { article, requestId: row.requestId, designId: row.designId, requestVersion: 0, slot: article.querySelector('[data-preview-slot]'), selected: null, row: null, feedback: '', orderDesign: true };
        items.push(item);
      }
      item.title = row.productMeta?.title || 'Your personalized item';
      item.article.querySelector('h3').textContent = item.title;
      item.article.querySelector('.cart-order-design-order').textContent = `${row.orderName ? `Order ${row.orderName}` : 'Order'} · Paid`;
      render(item, row);
      if (active === item && !item.saving) renderPanel(item);
    }
  }

  const hasPreview = (item, row = item.row) => row?.previewRequested === true || (item.article.dataset.previewFlow === 'legacy' && row?.previewRequested !== false);

  function productImage(item, url, index) {
    const image = item.article.querySelector('.simple-cart-media img');
    if (!image) return;
    item.catalogImage ||= Object.fromEntries(['src', 'srcset', 'sizes', 'alt'].map(name => [name, image.getAttribute(name)]));
    const attributes = url ? { src: url, srcset: null, sizes: null, alt: `${item.title} — confirmed design${Number.isInteger(index) ? `, Option ${index + 1}` : ''}` } : item.catalogImage;
    image.onerror = url ? () => productImage(item) : null;
    for (const [name, value] of Object.entries(attributes)) {
      if (value == null) image.removeAttribute(name);
      else if (image.getAttribute(name) !== value) image.setAttribute(name, value);
    }
    image.classList.toggle('is-confirmed-design', Boolean(url));
  }

  function render(item, row) {
    const previous = item.row;
    item.row = row;
    if (row?.reviewStatus === 'approved') item.selected = Number.isInteger(row.approvedDesignIndex) ? row.approvedDesignIndex : null;
    else if (row?.reviewStatus === 'changes_requested') item.selected = Number.isInteger(row.requestedDesignIndex) ? row.requestedDesignIndex : null;
    else if (previous?.designVersion !== row?.designVersion) item.selected = null;
    if (previous?.designVersion !== row?.designVersion) item.feedback = '';
    const images = imagesFor(row);
    const approvedImage = hasPreview(item, row) && row?.reviewStatus === 'approved' ? images[item.selected ?? (images.length === 1 ? 0 : -1)] : null;
    productImage(item, approvedImage, item.selected);
    if (!hasPreview(item, row)) { hide(item); return; }
    if (!images.length) {
      if (!row) { state(item, 'Your preview request status could not be confirmed.', true); return; }
      if (readOnly(row)) { state(item, 'This order can no longer be changed here. Please contact us to view its design.'); return; }
      state(item, 'Request received<small class="cart-design-queue-hints"><span class="cart-design-sr">Preview ready within 24 hours. We’ll email you when it’s ready.</span><span aria-hidden="true">Preview ready within 24 hours.</span><span aria-hidden="true">We’ll email you when it’s ready.</span></small>');
      item.slot.querySelector('.cart-design-summary-state').classList.add('is-designing');
      return;
    }
    const approved = row.reviewStatus === 'approved', changes = row.reviewStatus === 'changes_requested', locked = readOnly(row);
    const shown = approved ? [images[item.selected ?? 0]] : changes ? (item.selected === null ? [] : [images[item.selected]]) : images.slice(0, 3);
    const title = approved ? (item.selected === null ? 'Design confirmed' : `Option ${item.selected + 1} confirmed`) : changes ? (item.selected === null ? 'Changes requested' : `Option ${item.selected + 1} · Changes requested`) : host ? 'Your designs are ready' : `${images.length} design ${images.length === 1 ? 'option' : 'options'} ready`;
    item.slot.hidden = false;
    item.slot.innerHTML = `<button class="cart-design-summary-button${approved ? ' is-approved' : changes ? ' is-changes-requested' : ''}" type="button" data-preview-open aria-haspopup="dialog" aria-label="${escape((approved ? 'View confirmed design' : changes ? 'View requested changes' : 'View and choose a design') + ' for ' + item.title)}">${approved ? '' : `<span class="cart-design-miniatures">${shown.map(image => `<img src="${escape(image)}" alt="" loading="lazy">`).join('')}</span>`}<span class="cart-design-summary-copy"><strong>${title}</strong>${changes ? '<small>Waiting for an updated design</small>' : ''}</span>${host && !approved && !changes ? `<span class="cart-design-summary-count">${images.length} ${images.length === 1 ? 'option' : 'options'}</span>` : ''}<span class="cart-design-summary-link">${approved ? 'View design' : changes ? 'View feedback' : 'View & choose'} <span aria-hidden="true">→</span></span></button>`;
    item.slot.querySelector('[data-preview-open]').addEventListener('click', () => {
      active = item;
      renderPanel(item);
      if (host) {
        drawer.hidden = false;
        host.classList.add('is-reviewing');
        host.setAttribute('aria-labelledby', titleId);
        drawer.querySelector('[data-preview-back]').focus();
      } else { drawer.showModal(); document.documentElement.classList.add('cart-design-open'); }
    });
    if (locked) {
      item.slot.querySelector('.cart-design-summary-copy strong').textContent = 'Your order design';
      item.slot.querySelector('.cart-design-summary-link').textContent = 'View design →';
      item.slot.querySelector('[data-preview-open]').setAttribute('aria-label', `View design for ${item.title}`);
    }
  }

  function renderPanel(item) {
    stopThumbnailScroll();
    const row = item.row, images = imagesFor(row), approved = row.reviewStatus === 'approved', changes = row.reviewStatus === 'changes_requested', locked = readOnly(row);
    let viewed = item.selected ?? 0;
    drawer.innerHTML = `<div class="cart-design-panel"><header class="cart-design-panel-head">${host ? '<button type="button" data-preview-back>← Back to cart</button>' : ''}<h2 id="${titleId}"${host ? ' class="cart-design-sr"' : ''}>Review your design</h2><button type="button" data-preview-close aria-label="Close design review">${closeIcon}</button></header><div class="cart-design-panel-body"><p class="cart-design-product">${escape(item.title)}</p><p class="cart-design-intro">${approved ? (item.selected === null ? 'Your design is confirmed.' : `You confirmed Option ${item.selected + 1}.`) : changes ? (item.selected === null ? 'Waiting for an updated design. Your earlier feedback did not record an option.' : `Changes requested for Option ${item.selected + 1}. Waiting for an updated design.`) : 'Choose a thumbnail, then confirm your favorite.'}</p><button type="button" class="cart-design-main-image" data-preview-zoom ${changes && item.selected === null ? 'hidden' : ''} aria-label="Enlarge current design"><img alt=""><span>View larger ↗</span></button><div class="cart-design-navigation" ${changes ? 'hidden' : ''}><button type="button" data-preview-prev aria-label="Previous design">←</button><span data-preview-count></span><button type="button" data-preview-next aria-label="Next design">→</button></div><fieldset class="cart-design-options" ${changes ? 'hidden' : ''}><legend class="cart-design-sr">Choose one design option</legend>${images.map((image, index) => `<label class="cart-design-option"><input type="radio" name="cart-design-option" value="${index}" aria-label="Option ${index + 1}" ${item.selected === index ? 'checked' : ''} ${approved || changes ? 'disabled' : ''}><img src="${escape(image)}" alt="" loading="lazy"><span>${index + 1}</span></label>`).join('')}</fieldset>${row.reviewNote ? `<div class="cart-design-feedback"><strong>${item.selected === null ? 'Your requested changes' : `Your requested changes · Option ${item.selected + 1}`}</strong><p>${escape(row.reviewNote)}</p></div>` : ''}<div class="cart-design-change-form" hidden><label for="${feedbackId}" data-feedback-target>What would you like us to change?</label><textarea id="${feedbackId}" maxlength="1000" rows="3" placeholder="For example: move the text lower or adjust the hairstyle.">${escape(item.feedback || (changes ? row.reviewNote : ''))}</textarea><div class="cart-design-actions"><button class="cart-design-primary" type="button" data-preview-send>${changes ? 'Save feedback' : 'Send feedback'}</button><button class="cart-design-secondary" type="button" data-preview-cancel>Cancel</button></div></div></div><footer class="cart-design-panel-footer"><p class="cart-design-message" role="status" aria-live="polite"></p><div class="cart-design-actions" data-preview-actions>${approved || changes ? '' : `<button class="cart-design-primary" type="button" data-preview-confirm ${item.selected === null ? 'disabled' : ''}>${item.selected === null ? 'Select an option to confirm' : `Confirm Option ${item.selected + 1}`}</button>`}<button class="cart-design-secondary" type="button" data-preview-changes ${!changes && item.selected === null ? 'disabled' : ''}>${changes ? 'Edit feedback text' : 'Request changes'}</button></div><p class="cart-design-note">We’ll wait for your approval before production.</p></footer></div>`;
    const form = drawer.querySelector('.cart-design-change-form');
    form.hidden = true;
    const strip = drawer.querySelector('.cart-design-options');
    const navigation = drawer.querySelector('.cart-design-navigation');
    const intro = drawer.querySelector('.cart-design-intro'), introText = intro.textContent;
    strip.disabled = approved || changes || locked;
    strip.addEventListener('pointerdown', stopThumbnailScroll, { passive: true });
    strip.addEventListener('wheel', stopThumbnailScroll, { passive: true });
    function showOption(index, select = false) {
      if (select && (locked || changes || !form.hidden)) return;
      if (index < 0 || index >= images.length) return;
      viewed = index;
      const image = drawer.querySelector('.cart-design-main-image img');
      image.src = images[index]; image.alt = `Design option ${index + 1}`;
      drawer.querySelector('[data-preview-count]').textContent = `Option ${index + 1} of ${images.length}`;
      drawer.querySelector('[data-preview-prev]').disabled = index === 0;
      drawer.querySelector('[data-preview-next]').disabled = index === images.length - 1;
      if (select && !approved) {
        if (item.selected !== index) { item.feedback = ''; drawer.querySelector('textarea').value = ''; }
        item.selected = index;
      }
      drawer.querySelector('[data-preview-changes]').disabled = !changes && item.selected === null;
      drawer.querySelectorAll('.cart-design-option').forEach((card, position) => {
        card.classList.toggle('is-selected', position === item.selected);
        card.querySelector('input').checked = position === item.selected;
        if (position === viewed) scrollToThumbnail(card, select && document.documentElement.classList.contains('cart-pointer-input'));
      });
      const confirm = drawer.querySelector('[data-preview-confirm]');
      if (confirm) { confirm.disabled = item.selected === null; confirm.textContent = item.selected === null ? 'Select an option to confirm' : `Confirm Option ${item.selected + 1}`; }
    }
    drawer.querySelectorAll('input[type="radio"]').forEach(input => input.addEventListener('change', () => showOption(Number(input.value), true)));
    drawer.querySelector('[data-preview-prev]').addEventListener('click', () => showOption(viewed - 1, !locked));
    drawer.querySelector('[data-preview-next]').addEventListener('click', () => showOption(viewed + 1, !locked));
    drawer.querySelector('[data-preview-back]')?.addEventListener('click', closePanel);
    drawer.querySelector('[data-preview-close]').addEventListener('click', closePanel);
    drawer.querySelector('[data-preview-zoom]').addEventListener('click', () => {
      const image = viewer.querySelector('img'); image.src = images[viewed]; image.alt = `Design option ${viewed + 1}`;
      viewer.showModal();
    });
    drawer.querySelector('[data-preview-changes]').addEventListener('click', () => {
      if (!changes && item.selected === null) return;
      if (item.selected !== null) showOption(item.selected);
      stopThumbnailScroll();
      intro.textContent = item.selected === null ? 'Update your earlier feedback while our team prepares a new design.' : `Your feedback applies to Option ${item.selected + 1}.`;
      drawer.querySelector('[data-feedback-target]').textContent = item.selected === null ? 'Update your earlier feedback' : `What would you like to change about Option ${item.selected + 1}?`;
      strip.disabled = true;
      strip.hidden = true;
      navigation.hidden = true;
      const feedback = drawer.querySelector('.cart-design-feedback');
      if (feedback) feedback.hidden = true;
      drawer.querySelector('[data-preview-prev]').disabled = true;
      drawer.querySelector('[data-preview-next]').disabled = true;
      form.hidden = false;
      drawer.querySelector('[data-preview-actions]').hidden = true;
      form.querySelector('textarea').focus();
    });
    drawer.querySelector('[data-preview-cancel]').addEventListener('click', () => {
      form.hidden = true;
      item.feedback = '';
      drawer.querySelector('textarea').value = changes ? row.reviewNote || '' : '';
      intro.textContent = introText;
      strip.disabled = approved || changes;
      strip.hidden = changes;
      navigation.hidden = changes;
      const feedback = drawer.querySelector('.cart-design-feedback');
      if (feedback) feedback.hidden = false;
      showOption(viewed);
      drawer.querySelector('[data-preview-actions]').hidden = false;
      drawer.querySelector('[data-preview-changes]').focus();
    });
    drawer.querySelector('[data-preview-confirm]')?.addEventListener('click', () => save(item, 'approve'));
    drawer.querySelector('[data-preview-send]').addEventListener('click', () => save(item, 'request_changes'));
    showOption(viewed);
    if (locked) {
      drawer.querySelector('[data-preview-actions]').hidden = true;
      drawer.querySelectorAll('input,textarea,[data-preview-send]').forEach(control => { control.disabled = true; });
      intro.textContent = 'Your order design is available to view. This order can no longer be changed here.';
      drawer.querySelector('.cart-design-note').textContent = 'Please contact us if you need help with your order.';
    }
  }

  async function save(item, action) {
    if (destroyed || readOnly(item.row) || item.saving || item.needsVerification || previewLoading) return;
    const message = drawer.querySelector('.cart-design-message');
    const note = action === 'request_changes' ? drawer.querySelector('textarea').value.trim() : '';
    if (action === 'approve' && (item.selected === null || item.row.reviewStatus === 'changes_requested')) return;
    if (action === 'request_changes' && item.selected === null && item.row.reviewStatus !== 'changes_requested') return;
    if (action === 'request_changes' && !note) { message.textContent = 'Please describe the changes you would like.'; drawer.querySelector('textarea').focus(); return; }
    item.feedback = note;
    item.saving = true;
    const controls = [...drawer.querySelectorAll('button,input,textarea')].map(control => [control, control.disabled]);
    controls.forEach(([control]) => { control.disabled = true; });
    message.textContent = action === 'approve' ? 'Saving your selection…' : 'Sending your feedback…';
    const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 20000);
    reviewController = controller;
    let rejected = false;
    try {
      const response = await fetch(`${endpoint}/v1/customer-previews/${encodeURIComponent(item.row.requestId)}/review${identity}`, {
        method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'content-type': 'application/json' },
        body: JSON.stringify({ action, note, designIndex: item.selected, designVersion: item.row.designVersion }),
        signal: controller.signal,
      });
      const result = await response.json().catch(() => ({}));
      if (destroyed) return;
      rejected = !response.ok && response.status >= 400 && response.status < 500 && response.status !== 409 && Boolean(result.error);
      if (!response.ok || !result.preview) throw new Error(result.error || 'Your response could not be saved. Please try again.');
      if (host) host.dataset.previewChanged = 'true';
      item.feedback = '';
      render(item, result.preview);
      drawer.querySelector('textarea').value = '';
      item.saving = false;
      closePanel();
    } catch (error) {
      if (destroyed) return;
      clearTimeout(timer);
      if (rejected) {
        message.textContent = error.message;
        controls.forEach(([control, disabled]) => { control.disabled = disabled; });
      } else {
        // A lost response may have committed; verify before allowing another write.
        item.needsVerification = true;
        item.saving = false;
        if (host) host.dataset.previewChanged = 'true';
        drawer.querySelector('[data-preview-close]').disabled = false;
        const back = drawer.querySelector('[data-preview-back]');
        if (back) back.disabled = false;
        message.textContent = 'Your response may have been saved. Checking the latest design status…';
        const verified = await refresh({ silent: true });
        if (destroyed || active !== item) return;
        if (verified) {
          if (!item.row || !imagesFor(item.row).length) { drawer.querySelector('textarea').value = ''; closePanel(); return; }
          renderPanel(item);
          drawer.querySelector('.cart-design-message').textContent = 'Your latest design status is shown. Check it before making further changes.';
          return;
        }
        message.textContent = 'We could not verify whether your response was saved. Refresh designs before trying again.';
      }
      const retry = document.createElement('button');
      retry.type = 'button'; retry.className = 'cart-design-secondary'; retry.textContent = 'Refresh designs';
      retry.addEventListener('click', () => { closePanel(); void refresh(); }); message.append(' ', retry);
    } finally { clearTimeout(timer); if (reviewController === controller) reviewController = null; item.saving = false; }
  }

  function refresh({ silent = false } = {}) {
    if (destroyed) return;
    if (previewLoading) return previewLoading;
    const checkingOrderDesigns = emptyCart || Boolean(paidSection);
    const versions = items.map(item => item.requestVersion);
    previewLoading = (async () => {
      items.forEach(item => {
        item.slot.inert = true;
        item.slot.setAttribute('aria-busy', 'true');
        if (!hasPreview(item)) hide(item);
        else if (!silent) state(item, 'Loading design previews…');
      });
      let timer;
      try {
        if (globalThis.HeirloomPersonalizationServer) await globalThis.HeirloomPersonalizationServer.claimPending(root);
        if (destroyed) return;
        previewController = new AbortController();
        timer = setTimeout(() => previewController.abort(), 20000);
        const response = await fetch(`${endpoint}/v1/customer-previews${identity}`, { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store', signal: previewController.signal });
        const data = await response.json().catch(() => ({}));
        if (destroyed) return;
        if (response.status === 401) {
          syncPaid([]);
          cartItems.forEach((item, index) => { if (versions[index] !== item.requestVersion) return; item.row = null; item.selected = null; item.feedback = ''; signIn(item); });
          orderNotice(emptyCart ? 'Already ordered?' : '', false, emptyCart);
          return true;
        }
        if (!response.ok || !Array.isArray(data.previews)) {
          if (response.status === 403 || response.status === 404) syncPaid([]);
          throw new Error('unavailable');
        }
        orderNotice('');
        cartItems.forEach((item, index) => {
          if (versions[index] !== item.requestVersion) return;
          item.needsVerification = false;
          render(item, data.previews.find(row => matches(item, row)));
        });
        syncPaid(data.previews);
        return true;
      } catch { if (!destroyed) {
        items.forEach((item, index) => { if (versions[index] === item.requestVersion && hasPreview(item)) state(item, 'Design previews are temporarily unavailable.', true); });
        orderNotice(checkingOrderDesigns ? 'Order designs are temporarily unavailable.' : '', true);
      } }
      finally {
        clearTimeout(timer);
        previewController = null; previewLoading = null;
        items.forEach(item => { item.slot.inert = false; item.slot.setAttribute('aria-busy', 'false'); });
      }
    })();
    return previewLoading;
  }
  function signIn(item) {
    productImage(item);
    if (item.article.dataset.previewFlow !== 'legacy') { hide(item); return; }
    item.slot.hidden = false;
    item.slot.innerHTML = `<a class="cart-design-sign-in" href="${escape(root.dataset.customerLoginUrl || '/customer_authentication/login?return_to=%2Fcart')}"><svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><circle cx="12" cy="7" r="4"/><path d="M3 22v-3a9 9 0 0 1 18 0v3Z"/></svg><span>Sign in to request a design preview</span><span aria-hidden="true">›</span></a>`;
  }
  const requested = event => {
    const row = event.detail?.preview;
    if (destroyed || row?.previewRequested !== true) return;
    items.filter(item => matches(item, row)).forEach(item => { item.requestVersion++; render(item, row); });
  };
  const authenticated = () => { void refresh(); };
  let lastResume = 0;
  const resume = () => {
    if (destroyed || document.visibilityState === 'hidden' || (host && !host.open)) return;
    const now = Date.now();
    if (now - lastResume < 1500) return;
    lastResume = now;
    void refresh({ silent: true });
  };
  document.addEventListener('heirloom:preview-requested', requested);
  document.addEventListener('heirloom:customer-authenticated', authenticated);
  globalThis.addEventListener?.('focus', resume);
  globalThis.addEventListener?.('pageshow', resume);
  let destroyed = false, previewLoading = null, previewController = null, reviewController = null;
  if (root.dataset.customerLoggedIn === 'true') void refresh(); else items.forEach(signIn);
  if (root.dataset.customerLoggedIn !== 'true' && emptyCart) orderNotice('Already ordered?', false, true);
  return { close: closePanel, refresh, destroy() {
    destroyed = true;
    root.removeEventListener('toggle', detailsToggled, true);
    detailLoads.forEach(state => state.controller?.abort()); detailLoads.clear();
    document.removeEventListener?.('heirloom:preview-requested', requested);
    document.removeEventListener?.('heirloom:customer-authenticated', authenticated);
    globalThis.removeEventListener?.('focus', resume);
    globalThis.removeEventListener?.('pageshow', resume);
    previewController?.abort();
    reviewController?.abort();
    stopThumbnailScroll();
    if (active) leave();
    if (host) { host.classList.remove('is-reviewing'); host.setAttribute('aria-labelledby', 'HeirloomCartTitle'); }
    (host || drawer).removeEventListener('cancel', cancel);
    (host || drawer).removeEventListener('close', closed);
    viewer.remove(); drawer.remove();
    paidSection?.remove(); orderStatus?.remove();
    cartItems.forEach(item => { productImage(item); hide(item); item.slot.inert = false; item.slot.setAttribute('aria-busy', 'false'); });
  } };
  }
  globalThis.HeirloomCartPreview = { mount };
  document.querySelectorAll('[data-simple-cart]').forEach(root => {
    if (!root.closest('[data-cart-page-source]')) mount(root);
  });
})();
